import React, { Component } from 'react'
import { Col, Row, Input } from 'reactstrap'

import MassMessageModal from "../Material/MassMessageModal"
import CarIssueModal from "./CarIssueModal"
import withApolloClient from '../withApolloClient'
import AdvancedFiltersControl from '../Filters/AdvancedFiltersControl'
import AppliedAdvancedFilters from '../Filters/AppliedAdvancedFilters'

class MaintenanceListHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
        }
    }
    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }
    updateSearchTerm = (searchTerm) => {
        this.props.setFilterValues({ ...this.props.filterValues, searchTerm })
    }

    render() {
        // The two tabs list different entities -- Issues filters `car_issue`,
        // Jobs filters `job`. Computed once so AdvancedFiltersControl and
        // AppliedAdvancedFilters can never disagree about which tab they're on.
        const entity = this.props.activeTab === "Issues" ? "car_issue" : "job"
        return (
            <Row className="pb-2">
                {this.state.openModal === "MassMessageModal" && <MassMessageModal handleClose={() => this.toggleModal("MassMessageModal")} open={this.state.openModal === "MassMessageModal"} drivers={this.props.selectedDrivers && this.props.selectedDrivers.length > 0 ? this.props.selectedDrivers : null} />}
                {this.state.openModal === "createCarIssue" && <CarIssueModal isCreate open={this.state.openModal === "createCarIssue"} handleClose={() => this.toggleModal("createCarIssue")} refetchQuery={this.props.refetchQuery} />}
                <Col xs={4}>
                    <span className="driver-search-filter">
                        <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs={8} className="text-right mt-2">
                    {this.props.selectedDrivers && this.props.selectedDrivers.length > 0 &&
                        <>
                            <a className="driver-list-button" onClick={() => this.toggleModal("MassMessageModal")}>
                                Message Drivers | <i className="fa fa-commenting-o" aria-hidden="true"></i>
                            </a>&nbsp;&nbsp;&nbsp;
                        </>
                    }
                    {this.props.activeTab === "Issues" &&
                        <>
                            <a className="driver-list-button" onClick={() => this.toggleModal("createCarIssue")}>
                                Create Car Issue | <i className="fa fa-plus" aria-hidden="true"></i>
                            </a>&nbsp;&nbsp;&nbsp;
                        </>
                    }
                    <AdvancedFiltersControl
                        entity={entity}
                        compact={false}
                        presets={this.props.presets}
                        setPresets={this.props.setPresets}
                        defaultPresets={this.props.defaultPresets}
                    />
                </Col>
                <Col xs={12} className="mt-2">
                    {this.props.selectedDrivers && this.props.selectedDrivers.length > 0 && <span className="search-filter-preview">
                        <span> <i className="fa fa-times-circle" onClick={this.props.resetSelectedDrivers}></i> &nbsp;&nbsp; Selected Drivers</span>
                        {this.props.selectedDrivers.length}
                    </span>}
                </Col>
                <Col xs={12} className="mt-2 search-filter-container">
                    <AppliedAdvancedFilters
                        entity={entity}
                        context={null}
                        presets={this.props.presets}
                        onPresetsChange={this.props.setPresets}
                    />
                </Col>
            </Row>
        )
    }
}

export default withApolloClient(MaintenanceListHeader)
